









import { Component, Prop, Vue } from "vue-property-decorator";
import { InfoConfigBadge } from "@/utils/InfoConfigAdministration";
import { themedFill, themedFillTextClass } from "@/utils/Theme";

/** The Vuetify colour of the global target's chips; also the list header's "Globales Ziel" chip. */
export const GLOBAL_TARGET_CHIP_COLOR = "success";

/**
 * One badge of a Beschreibung version (`versionBadges`), as the version list and a version's page show
 * it: outlined primary for information, outlined warning for a warning, filled green for the global
 * target (through the dark status palette).
 */
@Component
export default class InfoConfigBadgeChipComponent extends Vue {
  @Prop({ required: true })
  badge!: InfoConfigBadge;

  get color(): string {
    if (this.badge.highlight) {
      return themedFill(GLOBAL_TARGET_CHIP_COLOR);
    }
    return this.badge.warning ? "warning" : "primary";
  }

  get textClass(): string {
    return this.badge.highlight ? themedFillTextClass(GLOBAL_TARGET_CHIP_COLOR, "white--text") : "";
  }
}
